








































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import cloneDeep from 'lodash/cloneDeep';

@Component
export default class ProjectEmailSignature extends Mixins(InputFieldMethods) {
    public contact: any = {
        companyName: null,
        address: null,
        city: null,
        zipCode: null,
        privacyPolicyUrl: null,
        websiteUrl: null,
        companyNumber: null,
        appStoreUrl: null,
        googlePlayUrl: null,
    };

    constructor() {
        super();
    }

    get project() {
        return this.$store.getters['Projects/getSelectedProject'];
    }

    @Watch('project')
    public projectChanged() {
        this.contact = cloneDeep(this.project.companyContact);
    }

    public updateProjectContactInfo() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.UPDATE_PROJECT_CONTACT, {
                    id: this.contact.id,
                    companyName: this.contact.companyName,
                    address: this.contact.address,
                    city: this.contact.city,
                    zipCode: this.contact.zipCode,
                    privacyPolicyUrl: this.contact.privacyPolicyUrl,
                    websiteUrl: this.contact.websiteUrl,
                    companyNumber: this.contact.companyNumber,
                    appStoreUrl: this.contact.appStoreUrl,
                    googlePlayUrl: this.contact.googlePlayUrl,
                    projectId: this.project.id,
                });
            }
        });
    }

    public created() {
        if (this.project.companyContact !== null) {
            this.contact = cloneDeep(this.project.companyContact);
        }
    }
}
